export default {
  MarketGroupList: () => import('@/views/marketGroup/listPage/MarketGroupList'),
}